var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"privacy-policy"},[_c('iframe',{attrs:{"src":"https://www.iubenda.com/privacy-policy/43113518","title":"Swampum terms and conditions"}})])])
}]

export { render, staticRenderFns }